// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"61443143","377":"e6e23435","417":"88f6cc16","467":"33a956cb","626":"e5e40771","870":"1a9453ba"}[chunkId] + ".js";
};